import type { FC } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import type { EmployeeCardWithDates } from '@pflegenavi/frontend/api-nursing-home';
import { useTranslation } from 'react-i18next';
import { EmployeeCardOverviewView } from './cards/EmployeeCardOverviewView';
import CreditCardIcon from '@mui/icons-material/CreditCard';

interface MyCardsPageContentProps {
  cards: EmployeeCardWithDates[];
}

export const MyCardsPageContent: FC<MyCardsPageContentProps> = ({ cards }) => {
  const { t } = useTranslation();

  if (cards.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 400,
          textAlign: 'center',
        }}
      >
        <CreditCardIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        <Typography
          variant="h6"
          sx={{
            color: 'text.secondary',
            mb: 1,
          }}
        >
          {t('myCards.emptyState.title')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            maxWidth: 500,
          }}
        >
          {t('myCards.emptyState.description')}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 3,
        }}
      >
        {t('myCards.description')}
      </Typography>
      <Grid container spacing={3}>
        {cards.map((card) => (
          <Grid
            key={card.id}
            size={{
              xs: 12,
              sm: 6,
              md: 4,
            }}
          >
            <EmployeeCardOverviewView card={card} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
